<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Array} containing one item which is a default item
   */
  export let dropdownItems
  export let selected = ""

  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {HTMLElement} binded the overall dropdown parent element
   */
  let dropdown

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="w-fir relative select-none" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="relative w-full bg-transparent bg-white py-2 text-left dark:bg-transparent sm:text-sm"
  >
    <!-- class="relative w-full rounded-md border border-[#a0a1a580] bg-transparent bg-white px-3 py-2 text-left focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-zinc-600 dark:bg-darkgray sm:text-sm" -->
    <div class="flex justify-between">
      <div class="text-sm text-gray-800 dark:text-white/70">{selected}</div>
      <!-- <div class="text-sm text-gray-800 dark:text-white/70">{query.limit}</div> -->
      <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center text-gray-200">
        <i class="fa-solid fa-chevron-down" />
      </div>
    </div>
  </button>
  <ul class:hidden={!showDropdown} class="absolute z-10 mt-1 max-h-56 w-full flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white text-base ring-opacity-5 focus:outline-none dark:border-zinc-600 dark:bg-darkgray sm:text-sm" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->

      <li
        on:click={(e) => {
          selected = item
          dispatch("itemSelect", item)
          showDropdown = false
        }}
        class="relative cursor-pointer select-none rounded-md px-5 py-2 {selected == item ? 'bg-blue-500 hover:bg-none' : 'bg-transparent hover:bg-[#f7f7f7] dark:hover:bg-bodyblack'}"
      >
        <div class="flex items-center">
          <div class="text-sm {selected == item ? 'font-semibold text-white' : 'text-gray-800 dark:text-gray-200'} ">{item}</div>
        </div>
      </li>
    {/each}
  </ul>
</div>
